var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckboxIndeterminatei = function SvgCheckboxIndeterminatei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "nonzero",
    d: "M4.41 21h15.18A1.41 1.41 0 0 0 21 19.59V4.41A1.41 1.41 0 0 0 19.59 3H4.41A1.41 1.41 0 0 0 3 4.41v15.18A1.41 1.41 0 0 0 4.41 21"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.08,
    strokeWidth: 1.4,
    d: "M19.59 20.3H4.41a.71.71 0 0 1-.71-.71V4.41a.71.71 0 0 1 .71-.71h15.18a.71.71 0 0 1 .71.71v15.18a.71.71 0 0 1-.71.71z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.2 12a.8.8 0 0 1 .8-.8h6a.8.8 0 1 1 0 1.6H9a.8.8 0 0 1-.8-.8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxIndeterminatei);
export default ForwardRef;